module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("William Rubens pushed his chair back from the table as the waiter approached. As a general rule Rubens hated luncheons such as these, which he derisively termed chicken and pea affairs. The food was actually poached salmon and scalloped potatoes, but it could easily have been rubber as far as his taste buds were concerned. If that weren’t bad enough, he faced the unwelcome prospect of sitting through three long speeches on the “state of the world” by people who knew less about international affairs than Jay Leno did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sensing his self-control slipping, Rubens rose and walked to the portable bar at the back of the room. He ordered a seltzer with a lime twist, then turned to survey the room silently.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’d say, ‘A dollar for your thoughts, Bill,’ but you’d probably feel insulted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Debra.” Rubens turned and nodded at Debra Collins, the CIA deputy director of operations or DDO.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charming lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Collins’ tone would have sounded sincere to anyone who didn’t know her as well as Rubens did. Her rise in the CIA had been fueled by a healthy disdain of many of the people she worked for, contempt she kept well hidden. Under oath, Rubens would have admitted that she was smarter than most of the people she worked with and in her own way quite brilliant, especially when it came to manipulating people.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could speak from first-hand experience: they had been lovers for a brief time some years before. He still rued the mistake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you for your personal attention on Peru,” he said. “Your people were insightful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course,” she said. “How is that business?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Proceeding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“An interesting election.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All elections are interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The president sees it as a cornerstone of his South American policy. I hope it proceeds fairly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” said Rubens.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The CIA had made several officers available for background briefings prior to the current Deep Black mission to Peru. It was a gesture of cooperation facilitated by the DDO, no doubt intended to show that Collins had no hard feelings about the mission, which had been authorized directly by the president and national security adviser. The complicated and delicate mission was precisely the sort Desk Three was invented to handle, but Rubens knew Collins felt that her people should have conducted it. Undoubtedly she saw it as yet one more instance of Deep Black encroaching on her agency’s domain. The CIA had made a strong play to “own” Desk Three when the high-tech covert group was first proposed, and Collins was nothing if not a sore loser.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Vice President Ortez is still running second, I see,” said Collins, sipping her drink—it would be a very weak vodka martini.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes,” said Rubens. “But the race is very close.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Much closer, in fact, than the polls showed—assuming the information Deep Black was working on was correct, Ortez was the one who was trying to steal the election.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Imberbe would be a good president,” said Collins. “Though I wouldn’t call him pro-American. Don’t you agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I really don’t have an opinion,” he told her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, you always have an opinion, Bill. You’re just very careful about sharing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Touché, thought Rubens. But he refused to be provoked. “I would say that the problems in Peru are so intractable that any leader would have a difficult time. Ortez has always been anti-American, and he’s been much more vocal about it than the present president. As for Imberbe, he is a reasonably intelligent man. The fact that the company he owns had done much business with America is a plus, and his statements would certainly lead one to think he would be more in sync with us than most of the others. But who can see the future?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not I.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was applause. The first speaker was ambling toward the podium.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If we can do anything more to help you, you’ll let us know,” said Collins.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tapped his shoulder gently. For just a moment, the shadow of what he had once felt for her crossed over him. It quickly lifted, but it left him confused and off-balance, uncharacteristically paralyzed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He forced himself to nod graciously. He reminded himself that she was a viper. He told himself that she must have some ulterior motive, that nothing Debra Collins did was accidental, that surely she had been watching for her chance to accost him all through the lunch. By the time Rubens returned to his table, he was back in control, his feelings—misguided, surely—safely locked in a place where they could neither interfere with his judgment nor surprise him with their ferocity again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc0f040c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429954921_ch05.vue
// module id = 81
// module chunks = 0